export const FETCH_STUDENT_DASHBOARD_REQUEST = 'FETCH_STUDENT_DASHBOARD_REQUEST';
export const FETCH_STUDENT_DASHBOARD_SUCCESS = 'FETCH_STUDENT_DASHBOARD_SUCCESS';
export const FETCH_STUDENT_DASHBOARD_FAILURE = 'FETCH_STUDENT_DASHBOARD_FAILURE';
export const UPDATE_STUDENT_PROGRESS = 'UPDATE_STUDENT_PROGRESS';